<template>
  <div>
    <section class="section">
      <h1 class="title">HoloRemote</h1>

      <div class="columns is-mobile">
        <div class="column">
          <h2 class="subtitle">別途ご連絡してる設定を記載してください。</h2>
        </div>
        <div class="column has-text-right is-one-quarter">
          <button class="button" @click="viewBatchArea">一括入力</button>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <div class="field">
            <label class="label">URL</label>
            <div class="control">
              <input
                type="text"
                v-model="sServerUrl"
                placeholder="http://127.0.0.1"
                class="input"
                maxlength="100"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <div class="field">
            <label class="label">ID</label>
            <div class="control">
              <input
                type="text"
                v-model="sConnectId"
                placeholder="abc@def"
                class="input"
                maxlength="30"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">KEY</label>
            <div class="control">
              <input
                type="password"
                v-model="sConnectKey"
                placeholder="abc123"
                class="input"
                maxlength="30"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column">
          <div class="field">
            <label class="label">UserName</label>
            <div class="control">
              <input
                type="text"
                v-model="sUserName"
                placeholder="username"
                class="input"
                maxlength="20"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="isUseGyroeye">
        <h2 class="title">Gyroeye Filelink</h2>

        <div class="columns is-mobile">
          <div class="column is-half">
            <div class="field">
              <label class="label">ACCESS_CODE</label>
              <div class="control">
                <input
                  type="text"
                  v-model="sGyroeyeAccessCode"
                  placeholder="XXXX-XXXX-XXXX-X"
                  class="input"
                  maxlength="30"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="{ 'notification is-danger': message!='' }">{{message}}</div>

      <div class="columns is-mobile">
        <div class="column">
          <div class="field">
            <label class="checkbox">
              <input type="checkbox" v-model="sSaveLocal" />
              ブラウザに入力情報を記録
            </label>
          </div>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <div class="field">
            <button class="button is-link" @click="sendEvent">ログイン</button>
          </div>
        </div>
      </div>
    </section>

    <div class="modal" v-bind:class="{ 'is-active': isBatchAreaShow }">
      <div class="modal-background" @click="hideBatchArea"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">設定を一括入力します</p>
          <button class="delete" aria-label="close" @click="hideBatchArea"></button>
        </header>
        <section class="modal-card-body">
          <textarea v-model="batchInputText" class="textarea" placeholder="{}"></textarea>
          <div v-bind:class="{ 'notification is-danger': batchMessage!='' }">{{batchMessage}}</div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="inputBatch">一括入力</button>
          <button class="button" @click="hideBatchArea">キャンセル</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import ServerAccess from "@/api/serveraccess";
import moment from "moment-timezone";

export default {
  name: "Login",
  data() {
    return {
      sServerUrl: "",
      sConnectId: "",
      sConnectKey: "",
      sUserName: "",
      sGyroeyeAccessCode: "",
      sGyroeyeClientId: "",
      sSaveLocal: false,
      message: "",
      batchInputText: process.env.HOLO_SORA_LOGIN_BATCH
        ? process.env.HOLO_SORA_LOGIN_BATCH
        : "",
      isBatchAreaShow: false,
      batchMessage: "",
      isUseGyroeye: false,
    };
  },
  created() {
    if (localStorage.getItem("sServerUrl"))
      this.sServerUrl = localStorage.getItem("sServerUrl");
    if (localStorage.getItem("sConnectId"))
      this.sConnectId = localStorage.getItem("sConnectId");
    if (localStorage.getItem("sConnectKey"))
      this.sConnectKey = localStorage.getItem("sConnectKey");
    if (localStorage.getItem("sUserName"))
      this.sUserName = localStorage.getItem("sUserName");
    if (localStorage.getItem("sGyroeyeAccessCode"))
      this.sGyroeyeAccessCode = localStorage.getItem("sGyroeyeAccessCode");

    //GyroeyeClientIdはlocalstrageに保存してあり無ければジェネレートする
    if (localStorage.getItem("sGyroeyeClientId")) {
      this.sGyroeyeClientId = localStorage.getItem("sGyroeyeClientId");
    } else {
      this.sGyroeyeClientId =
        "webuser_" +
        new Date().getTime() +
        "_" +
        Math.floor(Math.random() * 10000);
    }
    this.sSaveLocal = localStorage.getItem("sSaveLocal");
    if (
      process.env.HOLO_GYROEYE_FILELINK_LOGINURL &&
      process.env.HOLO_GYROEYE_FILELINK_SAVEURL
    ) {
      this.isUseGyroeye = true;
    }
  },
  methods: {
    // 保存ボタン
    async sendEvent() {
      if (
        !this.sServerUrl ||
        this.sServerUrl.length < 1 ||
        !this.sConnectId ||
        this.sConnectId.length < 1 ||
        !this.sConnectKey ||
        this.sConnectKey.length < 1 ||
        !this.sUserName ||
        this.sUserName.length < 1 ||
        (this.isUseGyroeye &&
          (!this.sGyroeyeAccessCode || this.sGyroeyeAccessCode.length < 1))
      ) {
        this.message = "入力内容を再度ご確認ください。";
        return;
      } else {
        this.message = "";
      }

      // localstrageに保存するかどうか
      if (this.sSaveLocal) {
        if (this.sServerUrl)
          localStorage.setItem("sServerUrl", this.sServerUrl);
        else localStorage.removeItem("sServerUrl");

        if (this.sConnectId)
          localStorage.setItem("sConnectId", this.sConnectId);
        else localStorage.removeItem("sConnectId");

        if (this.sConnectKey)
          localStorage.setItem("sConnectKey", this.sConnectKey);
        else localStorage.removeItem("sConnectKey");

        if (this.sUserName) localStorage.setItem("sUserName", this.sUserName);
        else localStorage.removeItem("sUserName");

        if (this.isUseGyroeye) {
          if (this.sGyroeyeAccessCode)
            localStorage.setItem("sGyroeyeAccessCode", this.sGyroeyeAccessCode);
          else localStorage.removeItem("sGyroeyeAccessCode");

          if (this.sGyroeyeClientId)
            localStorage.setItem("sGyroeyeClientId", this.sGyroeyeClientId);
          else localStorage.removeItem("sGyroeyeClientId");
        } else {
          localStorage.removeItem("sGyroeyeAccessCode");
          localStorage.removeItem("sGyroeyeClientId");
        }

        localStorage.setItem("sSaveLocal", true);
      } else {
        localStorage.removeItem("sServerUrl");
        localStorage.removeItem("sConnectId");
        localStorage.removeItem("sConnectKey");
        localStorage.removeItem("sUserName");
        localStorage.removeItem("sSaveLocal");
        localStorage.removeItem("sGyroeyeAccessCode");
        localStorage.removeItem("sGyroeyeClientId");
      }

      // ajax

      let url = this.sServerUrl + "/login";

      let settingRes;
      try {
        settingRes = await ServerAccess.getSoraSetting(
          url,
          this.sConnectId,
          this.sConnectKey,
          "Browser-" + this.sUserName
        );
        if (!settingRes || !settingRes.data || !settingRes.data.login) {
          throw {};
        }
      } catch (e) {
        this.message = "認証に失敗しました。入力内容を再度ご確認ください。";
        return;
      }

      let usersList = [];
      for (let u in settingRes.data.users) {
        if (settingRes.data.user_id != u) {
          let usr = settingRes.data.users[u];
          if (usr.status != "Idle") continue;
          let names = usr.name.split("-");
          usr.modelType = names.shift();
          usr.name = names.join("-");
          usersList.push(usr);
        }
      }

      let roomsList = [];
      for (let r in settingRes.data.rooms) {
        roomsList.push(settingRes.data.rooms[r]);
      }

      this.$router.push({
        name: "video",
        params: {
          soraData: {
            rooms: roomsList,
            users: usersList,
            sora: settingRes.data,
            setting: {
              url: this.sServerUrl,
              id: this.sConnectId,
              key: this.sConnectKey,
              filelinkaccesscode: this.isUseGyroeye
                ? this.sGyroeyeAccessCode
                : undefined,
              filelinkclientid: this.isUseGyroeye
                ? this.sGyroeyeClientId
                : undefined,
            },
          },
        },
      });
    },
    viewBatchArea() {
      this.batchMessage = "";
      this.isBatchAreaShow = true;
    },
    hideBatchArea() {
      this.batchMessage = "";
      this.isBatchAreaShow = false;
    },
    inputBatch() {
      try {
        let d = JSON.parse(this.batchInputText);
        if (d.url && d.id && d.key) {
          this.sServerUrl = d.url;
          this.sConnectId = d.id;
          this.sConnectKey = d.key;
          this.sGyroeyeAccessCode = d.filelinkaccesscode;
          this.hideBatchArea();
        } else {
          throw {};
        }
      } catch (e) {
        console.log(e);
        this.batchMessage = "入力を確認してください。";
      }
    },
  },
  watch: {
    sServerUrl: function (val) {
      this.message = val ? "" : "正しい値をいれてください。";
    },
    sConnectId: function (val) {
      this.message = val ? "" : "正しい値をいれてください。";
    },
    sConnectKey: function (val) {
      this.message = val ? "" : "正しい値をいれてください。";
    },
    sUserName: function (val) {
      this.message = val ? "" : "正しい値をいれてください。";
    },
    sGyroeyeAccessCode: function (val) {
      this.message =
        !this.isUseGyroeye || val ? "" : "正しい値をいれてください。";
    },
  },
  components: {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue